export const NonSteelGlassPriceMultiplier = 2.6;
export const SteelGlassPriceMultiplier = 3;

export const KompasDoubleGlazingPriceMultiplier = 1.5;
